import { Action as BaseAction } from '@ngrx/store';
import {
  User,
  FetchUsersParams,
  CreateUserParams,
  UpdateUserParams,
  UpdateUserStatusParams,
  UpdateUserPasswordParams,
} from '../../services/users/definitions';
import { ErrorAction } from '../main';
import { HttpErrorResponse } from '@angular/common/http';

export enum ActionTypes {
  ClearSelectedUser = 'Users.ClearSelectedUser',
  FetchUsers = 'Users.FetchUsers',
  FetchUsersSuccess = 'Users.FetchUsersSuccess',
  FetchUsersFailure = 'Users.FetchUsersFailure',
  CreateUser = 'Users.CreateUser',
  CreateUserSuccess = 'Users.CreateUserSuccess',
  CreateUserFailure = 'Users.CreateUserFailure',
  UpdateUser = 'Users.UpdateUser',
  UpdateUserPassword = 'Users.UpdateUserPassword',
  UpdateUserSuccess = 'Users.UpdateUserSuccess',
  UpdateUserFailure = 'Users.UpdateUserFailure',
  ClearUpdateUser = 'Users.ClearUpdateUser',
  ClearUpdateUserStatus = 'Users.ClearUpdateUserStatus',
  EnableUser = 'Users.EnableUser',
  DisableUser = 'Users.DisableUser',
  UserStatusUpdateSuccess = 'Users.UserStatusUpdateSuccess',
  UserStatusUpdateFailure = 'Users.UserStatusUpdateFailure',
}

// tslint:disable-next-line:max-line-length
export type Action =
  | ClearSelectedUser
  | FetchUsers
  | FetchUsersSuccess
  | FetchUsersFailure
  | CreateUser
  | CreateUserSuccess
  | CreateUserFailure
  | UpdateUser
  | UpdateUserPassword
  | UpdateUserSuccess
  | UpdateUserFailure
  | ClearUpdateUser
  | ClearUpdateUserStatus
  | EnableUser
  | DisableUser
  | UserStatusUpdateSuccess
  | UserStatusUpdateFailure;

// =============================================================================
// Clear Selected User
// =============================================================================
export class ClearSelectedUser implements BaseAction {
  readonly type = ActionTypes.ClearSelectedUser;
  constructor() {}
}

// =============================================================================
// Fetch Users
// =============================================================================

export type FetchUsersSuccessPayload = User[];
export type FetchUsersPayload = FetchUsersParams;

export class FetchUsers implements BaseAction {
  readonly type = ActionTypes.FetchUsers;
  constructor(public payload?: FetchUsersPayload) {}
}

export class FetchUsersSuccess implements BaseAction {
  readonly type = ActionTypes.FetchUsersSuccess;
  constructor(public payload: FetchUsersSuccessPayload) {}
}

export class FetchUsersFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.FetchUsersFailure;
  constructor(public error: HttpErrorResponse) {}
}

// =============================================================================
// Create Users
// =============================================================================

export type CreateUserPayload = CreateUserParams;
export type CreateUserSucessPayload = User;

export class CreateUser implements BaseAction {
  readonly type = ActionTypes.CreateUser;
  constructor(public payload: CreateUserPayload) {}
}

export class CreateUserSuccess implements BaseAction {
  readonly type = ActionTypes.CreateUserSuccess;
  constructor(public payload: CreateUserSucessPayload) {}
}

export class CreateUserFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.CreateUserFailure;
  constructor(public error: HttpErrorResponse) {}
}

// =============================================================================
// Update User Attributes
// =============================================================================

export type UpdateUserPayload = UpdateUserParams;

export class UpdateUser implements BaseAction {
  readonly type = ActionTypes.UpdateUser;
  constructor(public payload: UpdateUserPayload) {}
}

export class UpdateUserSuccess implements BaseAction {
  readonly type = ActionTypes.UpdateUserSuccess;
  constructor() {}
}

export class UpdateUserFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.UpdateUserFailure;
  constructor(public error: HttpErrorResponse) {}
}

// =============================================================================
// Clear Update User Status
// =============================================================================
export class ClearUpdateUser implements BaseAction {
  readonly type = ActionTypes.ClearUpdateUser;
  constructor() {}
}

// =============================================================================
// Enable / Disable Users
// =============================================================================

export type UpdateUserStatusPayload = UpdateUserStatusParams;

export class EnableUser implements BaseAction {
  readonly type = ActionTypes.EnableUser;
  constructor(public payload: UpdateUserStatusPayload) {}
}

export class DisableUser implements BaseAction {
  readonly type = ActionTypes.DisableUser;
  constructor(public payload: UpdateUserStatusPayload) {}
}

export class UserStatusUpdateSuccess implements BaseAction {
  readonly type = ActionTypes.UserStatusUpdateSuccess;
  constructor() {}
}

export class UserStatusUpdateFailure implements BaseAction, ErrorAction {
  readonly type = ActionTypes.UserStatusUpdateFailure;
  constructor(public error: Error) {}
}

// =============================================================================
// Clear Update User Status
// =============================================================================
export class ClearUpdateUserStatus implements BaseAction {
  readonly type = ActionTypes.ClearUpdateUserStatus;
  constructor() {}
}

// =============================================================================
// Update User Password
// =============================================================================

export type UpdateUserPasswordPayload = UpdateUserPasswordParams;

export class UpdateUserPassword implements BaseAction {
  readonly type = ActionTypes.UpdateUserPassword;
  constructor(public payload: UpdateUserPasswordPayload) {}
}
